import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { FaCheckCircle, FaAward, FaArrowRight, FaRocket } from 'react-icons/fa';
import './Expertise.css';

const Expertise = () => {
  const [expertiseData, setExpertiseData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchExpertiseData = async () => {
      try {
        const response = await fetch('https://api.ndtechland.com/api/HomeApi/GetOurExpertise');
        const result = await response.json();

        if (result.status === 200) {
          setExpertiseData(result.data);
        } else {
          console.error('Error fetching expertise data:', result.message);
        }
      } catch (error) {
        console.error('Error fetching expertise data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchExpertiseData();
  }, []);

  return (
    <div>
      <Header />

      <main className="nd-expertise-page">
        <div className="container">
          {/* Section Hero Header */}
          <div className="nd-expertise-hero">
            <div className="nd-hero-badge">
              <FaAward />
              <span>Our Core Capabilities</span>
            </div>
            <h1 className="nd-expertise-title">
              Our <span className="nd-gradient-accent">Expertise & Excellence</span>
            </h1>
            <p className="nd-expertise-subtitle">
              Empowering forward-thinking enterprises with robust engineering, state-of-the-art technological innovation, and dedicated industry expertise.
            </p>
          </div>

          {/* Dynamic Expertise Cards */}
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            expertiseData.map((expertise, index) => {
              const isEven = index % 2 === 0;
              const formattedIndex = String(index + 1).padStart(2, '0');

              return (
                <div className="nd-expertise-card" key={expertise.id || index}>
                  <div className="row align-items-center">
                    {/* Left Column */}
                    {isEven ? (
                      <>
                        <div className="col-lg-6 mb-4 mb-lg-0">
                          <div className="nd-card-content">
                            <span className="nd-card-index-pill">
                              <FaRocket /> Expertise #{formattedIndex}
                            </span>
                            <h2 className="nd-card-title">{expertise.expertiseName}</h2>
                            <p className="nd-card-desc">{expertise.description}</p>

                            <div className="nd-capabilities-list">
                              <span className="nd-cap-tag">
                                <FaCheckCircle /> Robust Engineering
                              </span>
                              <span className="nd-cap-tag">
                                <FaCheckCircle /> Industry-Proven
                              </span>
                              <span className="nd-cap-tag">
                                <FaCheckCircle /> Scalable Solutions
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="nd-img-wrapper">
                            <img
                              src={`https://api.ndtechland.com/image/${expertise.experiseImage}`}
                              alt={expertise.expertiseName}
                              loading="lazy"
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="col-lg-6 order-2 order-lg-1">
                          <div className="nd-img-wrapper">
                            <img
                              src={`https://api.ndtechland.com/image/${expertise.experiseImage}`}
                              alt={expertise.expertiseName}
                              loading="lazy"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 order-1 order-lg-2 mb-4 mb-lg-0">
                          <div className="nd-card-content">
                            <span className="nd-card-index-pill">
                              <FaRocket /> Expertise #{formattedIndex}
                            </span>
                            <h2 className="nd-card-title">{expertise.expertiseName}</h2>
                            <p className="nd-card-desc">{expertise.description}</p>

                            <div className="nd-capabilities-list">
                              <span className="nd-cap-tag">
                                <FaCheckCircle /> Continuous Innovation
                              </span>
                              <span className="nd-cap-tag">
                                <FaCheckCircle /> High Performance
                              </span>
                              <span className="nd-cap-tag">
                                <FaCheckCircle /> Client-Centric
                              </span>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              );
            })
          )}

          {/* Bottom Call to Action Banner */}

        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Expertise;
